import styled, { css, ThemeProvider } from 'styled-components';

export const WrapperAll = styled.div`
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 4px 0px;
  background-color: rgb(255, 255, 255);
  border: 1px solid rgb(230, 230, 230);
  border-radius: 6px;
  padding: ${props => props.theme.spacing.custom(10)};
  margin: ${props => props.theme.spacing.custom(10)} 0px;

  .head {
    font-size: 1.8rem;
    padding: 0.5rem 0;
  }

  .CityLinksWrp {
    padding: 1rem 0px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  .col1 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex-basis: 33.333%;
    flex-shrink: 0;
    flex-grow: 0;
    padding-right: 1rem;
  }

  .cityLink {
    color: rgb(44, 103, 179);
    outline: none;
    text-decoration: none;
    padding-bottom: 1rem;
  }

  @media (max-width: 768px) {
    .col1 {
      flex-basis: 50%;
    }
  }
`;
